export default (function (_ref) {
  var request = _ref.request;
  return {
    breedJoinDiseasesAdd: function breedJoinDiseasesAdd(data) {
      return request({
        url: '/cms/breedJoinDiseases/add',
        method: 'post',
        data: data
      });
    },
    breedJoinDiseasesModify: function breedJoinDiseasesModify(data) {
      return request({
        url: "/cms/breedJoinDiseases/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    breedJoinDiseasesDel: function breedJoinDiseasesDel(id) {
      return request({
        url: "/cms/breedJoinDiseases/".concat(id, "/del"),
        method: 'delete'
      });
    },
    breedJoinDiseasesQueryJoinDiseasesAndDiseasesCategory: function breedJoinDiseasesQueryJoinDiseasesAndDiseasesCategory(data) {
      return request({
        url: '/cms/breedJoinDiseases/queryJoinDiseasesAndDiseasesCategory',
        method: 'get',
        params: data
      });
    },
    breedJoinDiseasesDetail: function breedJoinDiseasesDetail(id) {
      return request({
        url: "/cms/breedJoinDiseases/".concat(id),
        method: 'get'
      });
    }
  };
});